import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Site } from 'src/app/models/site';
import { ServiceMethods, Paginated } from '@feathersjs/feathers';
import { VznFeathersService } from '@noammazuz/vzn-feathers';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Email } from 'src/app/models/email';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-site',
  templateUrl: './site.component.html',
  styleUrls: ['./site.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SiteComponent implements OnInit {
  loading: boolean;
  siteService: ServiceMethods<Site>;
  emailService: ServiceMethods<Email>;
  formSubmitService: ServiceMethods<any>;
  logsService: ServiceMethods<any>;
  error: string;
  site: Site;
  formGroup: FormGroup;
  sitePath: string;
  siteId: string;
  maillistId: string;
  emailId: string;
  contactId: string;
  step: string;
  dynamicStyle: HTMLStyleElement;

  constructor(
    private feathers: VznFeathersService<any>,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private titleService: Title,
    private router: Router,
    @Inject(DOCUMENT) private document: HTMLDocument
  ) {
    this.siteService = this.feathers.service('sites');
    this.emailService = this.feathers.service('emails');
    this.formSubmitService = this.feathers.service('form-submit');
    this.logsService = this.feathers.service('logs');
    this.formGroup = this.formBuilder.group({
      userName: '',
      password: '',
      selectionField: null
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle('');
    this.step = 'step1';
    this.loading = true;
    this.activatedRoute.queryParamMap.subscribe((queryParamMap: ParamMap) => {
      this.contactId = queryParamMap.get('ref');
    });
    this.activatedRoute.paramMap.subscribe(async (paramMap: ParamMap) => {
      const checkForHexRegExp = new RegExp('^[0-9a-fA-F]{24}$');
      this.sitePath = paramMap.get('sitePath');

      if (checkForHexRegExp.test(this.sitePath)) {
        this.site = await this.siteService.get(this.sitePath);
      }

      let email: Email;
      if (!this.site) {
        const res: Paginated<Email> = await this.emailService.find({
          query: {
            sitePath: this.sitePath
          }
        }) as Paginated<Email>;

        if (res.total > 0) {
          email = new Email(res.data[0]);
          this.site = email.site;
        }
      }

      if (!this.site || !this.site.active) {
        this.router.navigate(['404']);
        return;
      }

      this.siteId = this.site._id;
      this.maillistId = this.site.maillistId;
      this.emailId = email ? email._id : null;
      this.logsService.create({
        contactId: this.contactId,
        siteId: this.siteId,
        maillistId: this.maillistId,
        emailId: this.emailId,
        action: 'VIEW'
      });
      this.titleService.setTitle(this.site.siteTitle);
      this.generateDynamicStyle();
      this.loading = false;
    });
  }

  generateDynamicStyle() {
    if (this.site.favicon?.url) {
      this.document.querySelector('#appIcon').setAttribute('href', this.site.favicon?.url);
    }
    this.dynamicStyle = document.createElement('style');
    this.dynamicStyle.appendChild(document.createTextNode(`
        .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle {
            border-color: ${this.site.themeColor};
        }
        .mat-radio-button.mat-accent .mat-radio-inner-circle, .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple), .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple, .mat-radio-button.mat-accent:active .mat-radio-persistent-ripple {
            background-color: ${this.site.themeColor};
        }
    `));
    document.querySelector('head').appendChild(this.dynamicStyle);
  }

  position(direction: string) {
    let position = 'center';
    switch (direction) {
      case 'left': {
        position = this.site.direction === 'rtl' ? 'flex-end' : 'flex-start';
        break;
      }
      case 'right': {
        position = this.site.direction === 'rtl' ? 'flex-start' : 'flex-end';
        break;
      }
      case 'center': {
        position = 'center';
        break;
      }
    }
    return position;
  }

  async submitForm() {
    this.error = '';
    console.log(this.formGroup.value);
    if (!this.formGroup.value.userName) {
      this.error = 'אנא הזן שם משתמש';
      return;
    }
    if (!this.formGroup.value.password) {
      this.error = 'אנא הזן סיסמא';
      return;
    }
    if (!this.formGroup.value.selectionField && this.site.selectionField) {
      this.error = this.site.selectionFieldErrorMessage;
      return;
    }

    const formValue: any = {
      siteId: this.siteId,
      maillistId: this.maillistId,
      emailId: this.emailId,
      contactId: this.contactId,
      userName: this.formGroup.value.userName,
    };
    if (this.site.savePasswords) {
      formValue.password = this.formGroup.value.password;
    }
    const res = await this.formSubmitService.create(formValue);

    if (res.error) {
      this.error = 'שם משתמש או סיסמא לא נכונים';
    } else {
      this.step = 'step2';
    }
  }

}
